import { defineMessages } from 'react-intl';

export default defineMessages({
  flexible: {
    id: 'app.globalMessages.flexible',
    defaultMessage: 'Livre',
  },
  tryAgain: {
    id: 'app.globalMessages.tryAgain',
    defaultMessage: 'Tentar de novo',
  },
  connectionErrorSubtitle: {
    id: 'app.globalMessages.connectionErrorSubtitle',
    defaultMessage: 'Verifique sua conexão e tente de novo.',
  },
  sessionLoadError: {
    id: 'app.globalMessages.sessionLoadError',
    defaultMessage: 'Não foi possível carregar a sessão',
  },
});
